import React from 'react'
import { View, Text, Image, TouchableOpacity, StyleSheet } from 'react-native'
import theme from '../../../theme'
import styles from './StoreFormItemStyles'
import { placeholderGeneral } from '../customUtils/Constants'
import { useFormContext } from './context/form.context'
import { FORM_SCHEDULE_STATUS, FORM_TYPES } from './constants/constants.stores'
import { Ionicons } from '@expo/vector-icons'
import { getLanguage } from '../appBar/context/LocalizationContext'
import {
    colorFilterSelected,
    colorFilterUnselected,
    colorFilterTextSelected,
    colorFilterTextUnselected,
    colorFilterIconSelected,
    colorFilterIconUnselected,
    colorFilterUnselectedPS,
} from '../../../themeConstants'

export const StoreFormItemPS = ({
    name,
    image,
    index,
    onClickItem,
    isSelected,
}: {
    name: string
    image: string
    index: number
    onClickItem: (index: number) => void
    isSelected: boolean
}) => {
    return (
        <View style={styles.containerLabels}>
            <TouchableOpacity
                style={[
                    styles.flatFlags,
                    {
                        backgroundColor: isSelected
                            ? colorFilterSelected
                            : colorFilterUnselectedPS,
                        borderColor: isSelected
                            ? colorFilterSelected
                            : colorFilterUnselected,
                    },
                ]}
                onPress={() => onClickItem(index)}
            >
                <Image
                    style={[
                        styles.image,
                        {
                            tintColor: isSelected
                                ? colorFilterIconSelected
                                : colorFilterIconUnselected,
                        },
                    ]}
                    source={{ uri: image ? image : placeholderGeneral }}
                />

                <Text
                    style={[
                        isSelected
                            ? styles.flatItemsSelected
                            : styles.flatItemsUnselected,
                        {
                            color: isSelected
                                ? colorFilterTextSelected
                                : colorFilterTextUnselected,
                        },
                    ]}
                >
                    {name}
                </Text>
            </TouchableOpacity>
        </View>
    )
}

export const StoreFormItem = ({
    //renderiza cada item de los tabs
    name,
    image,
    index,
    onClickItem,
    isSelected,
}: {
    name: string
    image: string
    index: number
    onClickItem: (index: number) => void
    isSelected: boolean
}) => {
    const { formsContext } = useFormContext()
    let locked = false
    if (formsContext.length > 0) {
        const repeat = formsContext[index].repeat
        const status = formsContext[index].status

        const isFormRedirect =
            formsContext[index].type_form.type === FORM_TYPES.FORM_REDIRECT
        if (
            (status === FORM_SCHEDULE_STATUS.COMPLETED ||
                status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION) &&
            !repeat &&
            !isFormRedirect
        ) {
            locked = true
        }
    }
    return (
        <View style={styles.containerLabels}>
            <TouchableOpacity
                style={[
                    styles.flatFlags,
                    {
                        backgroundColor: isSelected
                            ? theme.colors.colorPrimary
                            : locked
                              ? theme.colors.lightGray
                              : 'white',
                        borderColor: locked
                            ? theme.colors.lightGray
                            : theme.colors.colorPrimary,
                    },
                ]}
                onPress={() => onClickItem(index)}
            >
                {locked ? (
                    <Ionicons
                        name={'checkmark-sharp'}
                        size={18}
                        style={styles.icon}
                        color={theme.colors.colorApproved}
                    />
                ) : (
                    <Image
                        style={[
                            styles.image,
                            {
                                tintColor: isSelected
                                    ? 'white'
                                    : locked
                                      ? theme.colors.darkGray
                                      : theme.colors.colorPrimary,
                            },
                        ]}
                        source={{ uri: image ? image : placeholderGeneral }}
                    />
                )}

                <Text
                    style={
                        isSelected
                            ? styles.flatItemsSelected
                            : locked
                              ? styles.flatItemsLocked
                              : styles.flatItemsUnselected
                    }
                >
                    {name}
                </Text>
            </TouchableOpacity>
        </View>
    )
}

export const StoreFormMV = ({ name }: { name: string }) => {
    const { languageFile } = getLanguage()

    return (
        <View style={styles.containerStoreFormMV}>
            <Text style={styles.name}>{name?.toUpperCase()}</Text>
            <Text style={styles.survey}>{languageFile.take_the_survey}</Text>
        </View>
    )
}
